/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Password_Policy_HintInputs */



/**
* | output |
* | --- |
* | "Use at least 10 characters with uppercase, lowercase, a number, and a symbol." |
*
* @param {Login_Password_Policy_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_password_policy_hint = /** @type {((inputs?: Login_Password_Policy_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Password_Policy_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Utilisez au moins 10 caractères avec majuscules, minuscules, un chiffre et un symbole.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwenden Sie mindestens 10 Zeichen mit Groß- und Kleinbuchstaben, einer Zahl und einem Symbol.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Usa almeno 10 caratteri con maiuscole, minuscole, un numero e un simbolo.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Используйте не менее 10 символов с заглавными и строчными буквами, цифрой и символом.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Use al menos 10 caracteres con mayúsculas, minúsculas, un número y un símbolo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请使用至少 10 个字符，包含大小写字母、数字和符号。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("大文字・小文字・数字・記号を含む10文字以上を使用してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बड़े अक्षर, छोटे अक्षर, अंक और प्रतीक सहित कम से कम 10 अक्षरों का उपयोग करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Use pelo menos 10 caracteres com maiúsculas, minúsculas, um número e um símbolo.")
	return /** @type {LocalizedString} */ ("Use at least 10 characters with uppercase, lowercase, a number, and a symbol.")
});